"use client";

import React from "react";

export function useMergeRefs<T>(
  ...refs: (React.Ref<T> | undefined)[]
): React.RefCallback<T> {
  return React.useCallback(
    (value: T) => {
      for (const ref of refs) {
        if (typeof ref === "function") {
          ref(value);
        } else if (ref && typeof ref === "object") {
          (ref as React.MutableRefObject<T | null>).current = value;
        }
      }
    },
    [refs],
  );
}
